<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">{{title$|async}}</h3>
    </div>
  </div>
  <form [formGroup]="form" class="form">
    <div class="card-body">
      <div class="row">
        <div class="col-12">
          <mat-form-field class="mat-form-field-fluid">
            <mat-select placeholder="Area Unit Type" formControlName="unit_area_measurement_id">
              <mat-option *ngFor="let unitAreaMeasurement of unitAreaMeasurements$|async"
                [value]="unitAreaMeasurement.id">{{unitAreaMeasurement.name}}</mat-option>
            </mat-select>
            <mat-error>
              Area Unit Type
              <strong>required</strong>
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 kt-margin-bottom-20-mobile">
          <mat-form-field class="mat-form-field-fluid">
            <input matInput placeholder="Surface" formControlName="surface" mask="separator" thousandSeparator="," />
            <mat-error>
              Surface
              <strong>required</strong>
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 kt-margin-bottom-20-mobile">
          <mat-form-field class="mat-form-field-fluid">
            <input matInput placeholder="Restricted / limited use" formControlName="limited_use" />
            <mat-error>
              Restricted / limited use
              <strong>required</strong>
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12 kt-margin-bottom-20-mobile">
          <mat-form-field class="mat-form-field-fluid">
            <input matInput placeholder="Underground restrictions (depth)" formControlName="underground_restriction"
              mask="separator" thousandSeparator="," />
            <mat-error>
              Underground restrictions (depth)
              <strong>required</strong>
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12 kt-margin-bottom-20-mobile">
          <mat-form-field class="mat-form-field-fluid">
            <input matInput placeholder="Aerial restriction (height)" formControlName="aerial_restriction"
              mask="separator" thousandSeparator="," />
            <mat-error>
              Aerial restriction (height)
              <strong>required</strong>
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12 kt-margin-bottom-20-mobile">
          <mat-form-field class="mat-form-field-fluid">
            <mat-select placeholder="Length Unit Type" formControlName="unit_length_measurement_id">
              <mat-option *ngFor="let unitLengthMeasurement of unitLengthMeasurements$|async"
                [value]="unitLengthMeasurement.id">{{unitLengthMeasurement.name}}</mat-option>
            </mat-select>
            <mat-error>
              Length Unit Type
              <strong>required</strong>
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="card-footer p-0 b-0">
      <div class="form-actions form-actions-solid">
        <div class="row text-right">
          <div class="col-lg-12">
            <button type="button" mat-raised-button cdkFocusInitial (click)="onClose()">
              Close
            </button>&nbsp;
            <button type="button" class="btn btn-success" mat-raised-button color="submit" (click)="onSubmit()">
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>